import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { DomainsService } from './domains.service';
import { GridOptions, IGetRowsParams, GridApi, ColumnApi, IDatasource } from 'ag-grid-community';
import { DOMAINS_DEFAULT_COL_DEF, DOMAINS_COL_DEFS } from './domains.model';
import { StyleComponent } from './components/style/style.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { IEntityDomain } from 'projects/pplus/src/lib/interfaces/interfaces';
import { RowDataService } from 'projects/pplus/src/lib/components/split-form/services/row-data.service';
import { AgCheckboxComponent } from 'projects/pplus/src/lib/components/ag-grid/ag-checkbox/ag-checkbox.component';
import { AgBoolFilterComponent } from 'projects/pplus/src/lib/components/ag-grid/ag-bool-filter/ag-bool-filter.component';
import { AgBoolFloatingFilterComponent } from 'projects/pplus/src/lib/components/ag-grid/ag-bool-filter/ag-bool-floating-filter/ag-bool-floating-filter.component';
import { NbDialogService } from '@nebular/theme';
import { Observable, forkJoin } from 'rxjs';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-domains',
  templateUrl: './domains.component.html',
  styleUrls: ['./domains.component.scss']
})
export class DomainsComponent implements OnInit {
  @ViewChild('splitContent', { static: false }) splitContent;
  @ViewChild('agGrid', { read: ElementRef, static: false }) agGridNativeElement: ElementRef;
  @ViewChild('dialog', { read: TemplateRef, static: false }) dialogRef: TemplateRef<unknown>;

  splitOptions = {
    open: false,
    direction: 'horizontal',
    contentSize: 100,
    formSize: 0,
  };

  contextMenu = {
    X: 0,
    Y: 0,
    state: false,
  };

  row: IEntityDomain = <IEntityDomain>{};

  TitleForm = 'Detalles';
  gridApi: GridApi;
  gridColumnApi: ColumnApi;
  gridOptions: GridOptions = {
    defaultColDef: DOMAINS_DEFAULT_COL_DEF,
    columnDefs: DOMAINS_COL_DEFS,
    rowModelType: 'infinite',
    rowSelection: 'multiple',
    frameworkComponents: {
      checkboxComponent: AgCheckboxComponent,
      boolFilter: AgBoolFilterComponent,
      boolFloatingFilter: AgBoolFloatingFilterComponent,
      styleComponent: StyleComponent,
    },
    floatingFilter: true,
    accentedSort: true,
  };

  private agDataSource: IDatasource = {
    rowCount: null,
    getRows: (rowParams: IGetRowsParams) => this.domainService.getAllDomainsInfiniteScroll(
      rowParams.startRow, rowParams.endRow, rowParams.sortModel, rowParams.filterModel
    ).subscribe(res => rowParams.successCallback(this.processDomainsFields(res.entityDomains), res.lastRow))
  };

  constructor(
    private domainService: DomainsService,
    private dataRow: RowDataService,
    private breakPointObserver: BreakpointObserver,
    private nbDialogService: NbDialogService,
    private adminService: AdminService,
  ) {}

  ngOnInit() {}

  private processDomainsFields(domains: IEntityDomain[]): IEntityDomain[] {
    for (const domain of domains) if (this.row && this.row.entityDomainId === domain.entityDomainId) {
      this.row = <IEntityDomain>JSON.parse(JSON.stringify(domain));
      this.dataRow.updateRowData(this.row);
    }
    return domains;
  }

  onGridRowClicked(row) {
    this.row = <IEntityDomain>JSON.parse(JSON.stringify(row.data));
    this.dataRow.updateRowData(this.row);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    window.addEventListener('resize', function () {
      setTimeout(function () {
        params.api.sizeColumnsToFit();
      });
    });
    this.agGridNativeElement.nativeElement.addEventListener('contextmenu', function ($event: any) {
      $event.preventDefault();
    });
    this.gridOptions.api.setDatasource(this.agDataSource);
  }

  onCellContextMenu($event) {
    $event.event.preventDefault();
    const e = $event.event;

    let posx = 0;
    let posy = 0;

    if (e.pageX || e.pageY) {
      posx = e.pageX;
      posy = e.pageY;
    } else if (e.clientX || e.clientY) {
      posx = e.clientX + document.body.scrollLeft +
        document.documentElement.scrollLeft;
      posy = e.clientY + document.body.scrollTop +
        document.documentElement.scrollTop;
    }

    this.contextMenu = {
      X: posx,
      Y: posy,
      state: true
    };
  }

  rowDoubleClicked(event: any) {
    this.openSplit();
  }

  openSplit() {
    this.breakPointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(res => {
      if (res.matches) {
        this.splitOptions = {
          open: true,
          direction: 'horizontal',
          contentSize: 0,
          formSize: 100,
        };
      } else {
        this.splitOptions = {
          open: true,
          direction: 'horizontal',
          contentSize: 70,
          formSize: 30,
        };
      }
    });
  }

  readSplitOptions(event: any) {
    if (event.opt) {
      this.splitOptions = event.opt;
    }
  }

  updateData(isCreation: boolean) {
    if (isCreation) this.row = null;
    this.gridOptions.api.refreshInfiniteCache();
  }

  quickSearch(data: string) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(data);
    }
  }

  resizeGrid(event: any) {
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  clearRow() {
    this.row = <IEntityDomain>{};
    this.dataRow.updateRowData(this.row);
  }

  generalSearch(value: string) {
    if (value) this.gridOptions.api.setDatasource({
      rowCount: null,
      getRows: (rowParams: IGetRowsParams) => this.domainService.getDomainsGeneralFilter(
        value, rowParams.startRow, rowParams.endRow, rowParams.sortModel, rowParams.filterModel
      ).subscribe(res => rowParams.successCallback(this.processDomainsFields(res.entityDomains), res.lastRow))
    });
    else this.gridOptions.api.setDatasource(this.agDataSource);
  }

  deleteSelected() {
    if (this.gridApi) {
      const selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows && selectedRows.length) this.nbDialogService.open(
        this.dialogRef, { context: 'Are you sure you want to delete all selected domains?' }
      ).onClose.subscribe(accepted => {
        if (accepted) {
          const deleteCalls: Observable<boolean>[] = [];
          for (const row of selectedRows) deleteCalls.push(this.domainService.deleteDomain(row.entityDomainId));
          forkJoin(deleteCalls).subscribe(success => {
            if (success.every(b => b === true)) {
              this.adminService.showToast('success', 'All selected domains deleted');
            } else {
              this.adminService.showToast('danger', 'One or more domains couldn\'t be deleted');
            }
            this.clearRow();
            this.gridApi.refreshInfiniteCache();
            this.gridApi.deselectAll();
          });
        }
      });
    }
  }

}
